import { render, staticRenderFns } from "./SectionForUserSmartPOST.vue?vue&type=template&id=18002c15&scoped=true"
import script from "./SectionForUserSmartPOST.vue?vue&type=script&lang=ts"
export * from "./SectionForUserSmartPOST.vue?vue&type=script&lang=ts"
import style0 from "./SectionForUserSmartPOST.vue?vue&type=style&index=0&id=18002c15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18002c15",
  null
  
)

export default component.exports